export const noSpreadBetsQuery = {
	bool: {
		must_not: [
			{
				term: {
					marketDisplayName: 'Point Spread',
				},
			},
		],
	},
};
